var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249,
    height: 248,
    viewBox: "0 0 249 248",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_b_689_33394)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.566406,
    width: 247.863,
    height: 247.863,
    rx: 123.932,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.06641,
    y: 0.5,
    width: 246.863,
    height: 246.863,
    rx: 123.432,
    stroke: "#E9E9E9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter1_b_689_33394)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.8242,
    y: 15.2578,
    width: 217.349,
    height: 217.349,
    rx: 108.674,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3242,
    y: 15.7578,
    width: 216.349,
    height: 216.349,
    rx: 108.174,
    stroke: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter2_b_689_33394)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.082,
    y: 30.5156,
    width: 186.833,
    height: 186.833,
    rx: 93.4163,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.582,
    y: 32.0156,
    width: 183.833,
    height: 183.833,
    rx: 91.9163,
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.697 95.2213L177.691 95.2135C177.162 94.5229 176.482 93.9633 175.703 93.5768C174.925 93.1903 174.068 92.9869 173.199 92.9815H173.186H95.6793L92.4043 81.5826L92.4043 81.5826L92.4012 81.5721C91.8364 79.6458 90.6596 77.9553 89.0498 76.7515C87.4402 75.548 85.4834 74.8949 83.4719 74.8877V74.8877H83.4647H75.8094C74.3169 74.8877 72.8826 75.4761 71.8227 76.5282C70.7624 77.5808 70.1641 79.0115 70.1641 80.5065C70.1641 82.0014 70.7624 83.4321 71.8227 84.4847C72.8826 85.5368 74.3169 86.1252 75.8094 86.1252H81.9616L85.9303 99.8339V99.923L86.0085 100.194L98.0382 141.946L98.0399 141.952C98.8225 144.636 100.46 146.993 102.704 148.671C104.947 150.348 107.677 151.257 110.482 151.263H110.486L154.139 151.263L154.143 151.263C156.949 151.257 159.678 150.348 161.921 148.671C164.165 146.993 165.803 144.636 166.585 141.952L166.587 141.945L178.617 100.149L178.617 100.147C178.857 99.3109 178.899 98.4306 178.739 97.5754C178.579 96.7203 178.222 95.9146 177.697 95.2213ZM163.729 168.876C164.752 167.356 165.298 165.568 165.298 163.738C165.298 161.283 164.316 158.932 162.572 157.201C160.828 155.47 158.467 154.5 156.008 154.5C154.173 154.5 152.379 155.04 150.852 156.053C149.324 157.067 148.131 158.509 147.426 160.198C146.721 161.888 146.536 163.748 146.896 165.543C147.256 167.338 148.143 168.984 149.443 170.275C150.743 171.566 152.398 172.443 154.198 172.799C155.997 173.154 157.862 172.972 159.558 172.274C161.254 171.577 162.706 170.395 163.729 168.876ZM108.618 154.5C106.783 154.5 104.989 155.04 103.462 156.054C101.934 157.067 100.741 158.509 100.036 160.198C99.3312 161.888 99.1465 163.748 99.5061 165.543C99.8657 167.338 100.753 168.984 102.053 170.275C103.354 171.566 105.009 172.443 106.808 172.799C108.607 173.154 110.473 172.972 112.168 172.274C113.864 171.577 115.316 170.395 116.339 168.876C117.362 167.356 117.909 165.568 117.909 163.738C117.909 161.283 116.926 158.932 115.182 157.201C113.439 155.47 111.077 154.5 108.618 154.5Z",
    stroke: "#0E2B3A",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.5 58.6426C134.5 57.538 133.605 56.6426 132.5 56.6426C131.395 56.6426 130.5 57.538 130.5 58.6426H134.5ZM132.5 102.985L144.047 82.9849H120.953L132.5 102.985ZM130.5 58.6426V84.9849H134.5V58.6426H130.5Z",
    fill: "#0E2B3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.41 136.812C121.638 133.583 125.331 131.083 129.703 129.675C133.399 128.485 137.813 127.508 141.772 128.035C145.1 128.479 148.444 128.957 151.045 130.69",
    stroke: "#0E2B3A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.576 112.503C117.819 113.731 118.314 114.838 118.789 115.988C118.882 116.21 119.344 116.874 119.629 116.89C121.239 116.979 121.439 115.102 121.122 113.976C120.86 113.042 120.278 111.921 119.536 111.29C119.323 111.109 118.505 110.592 117.852 111.038C117.294 111.421 117.576 112.145 117.576 112.429",
    stroke: "#0E2B3A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.323 113.243C142.129 112.227 142.041 111.162 141.753 110.168C141.548 109.349 142.055 109.315 142.597 108.96C143.405 108.786 143.241 108.889 143.92 108.96C144.204 108.99 144.642 109.622 144.739 109.868C145.003 110.535 145.383 111.237 145.465 111.962C145.547 112.695 145.603 114.053 144.77 114.42C144.26 114.644 143.639 114.755 143.09 114.591C142.675 114.466 142.394 113.614 142.323 113.243Z",
    fill: "#0E2B3A",
    stroke: "#0E2B3A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_689_33394",
    x: -69.4336,
    y: -70,
    width: 387.863,
    height: 387.863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_689_33394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_689_33394",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_689_33394",
    x: -54.1758,
    y: -54.7422,
    width: 357.349,
    height: 357.349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_689_33394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_689_33394",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_689_33394",
    x: -38.918,
    y: -39.4844,
    width: 326.833,
    height: 326.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_689_33394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_689_33394",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductEmpty);
export default __webpack_public_path__ + "static/media/productEmpty.6b4bc10776702e6b61a0dba06e84573e.svg";
export { ForwardRef as ReactComponent };